// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"AssetCheckbox_checkbox__32wJ8","title":"AssetCheckbox_title__2I4n8"};